import { flatsListAPI } from "@/views/FlatList/api";

export const getFloorOptions = async (body) => {
  try {
    const res = await flatsListAPI.getFloors(body);
    return res?.data;
  } catch (e) {}
};